import { render, staticRenderFns } from "./RegTicketPop.vue?vue&type=template&id=9db5bc98&scoped=true&"
import script from "./RegTicketPop.vue?vue&type=script&lang=js&"
export * from "./RegTicketPop.vue?vue&type=script&lang=js&"
import style0 from "./RegTicketPop.vue?vue&type=style&index=0&id=9db5bc98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db5bc98",
  null
  
)

export default component.exports